import React, { Component } from 'react';
import './RadioButton.css';

import FontIcon from '../../components/fontIcon/FontIcon';

export default class RadioButton extends Component {
	constructor(props) {
		super(props);
		this.state = { value: this.props.value };
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
			this.setState({ value: nextProps.value });
		}
	}

	toggleSelected = () => {
		let value = !this.state.value;
		this.setState({ value });
		if (this.props.onChange) {
			this.props.onChange(value);
		}
	};

	_classes = () => {
		let classes = ['g-radio-button'];
		if (this.state.value) {
			classes.push('selected');
		}
		return classes.join(' ');
	};

	_iconName = () => {
		if (this.state.value) return 'icon-radio-button-on';
		return 'icon-radio-button-off';
	};

	render() {
		return <FontIcon onClick={this.toggleSelected} name={this._iconName()} className={this._classes()} />;
	}
}



// WEBPACK FOOTER //
// ./src/inputs/radioButton/RadioButton.jsx